/* DEMO collection grid (29 Oct, v10).
   1. Marks a card 'dc-hasrev' once the Feefo widget has drawn its stars, so the grey placeholder stars hide behind the real ones.
   2. Quantity box: the - and + buttons change the number; BUY NOW adds that many with the store's own /cart/add.js, using the same kind of request the theme always used so the basket panel redraws, then runs the theme's own 'added to cart' routine.
   (v10, 2 Nov) BUY NOW now ALWAYS adds by itself, even for 1 item. Before, 1 item was left to the theme's own button code, which only attaches to cards that were on the page at load - so cards drawn afterwards (Frequently bought together, Load more on phones) did nothing when pressed.
   Works on the collection grid (#product-listings), the Featured Products block (#featured-products), the Recently viewed row (#dc-recent), Frequently bought together (#dc-fbt) and the homepage rows (#dc-popular best sellers, .dc-feat big picture + top sellers, .dc-fp featured products).
   3. (v7) Filter box labels: 'Refine by Type' becomes just 'Type' (looks only, the filters themselves are untouched).
   4. (v8) Design-only products (Double Wall Cups): on ANY card anywhere (grid, featured, recently viewed, homepage rows) the Buy Now + quantity box is swapped for a DESIGN button to the product page, and the price reads 'From 11p'. To add a product, add its handle to DESIGN_HANDLES.
   5. (v9) Blog pages: the long list of tags in the sidebar becomes one 'Browse by tag' dropdown (picking a tag opens that tag's articles). Undo = delete blogTags() and its two calls. */
(function () {
  var DESIGN_HANDLES = ['double-wall-cups'];
  var DESIGN_FROM = '£0.11';

  function check(box) {
    var w = box.querySelector('.feefo-product-stars-widget');
    if (!w) return;
    var drawn = w.children.length > 0 || w.textContent.replace(/[\s ]/g, '') !== '';
    box.classList.toggle('dc-hasrev', drawn);
  }
  function run() {
    var boxes = document.querySelectorAll('#product-listings .dc-stars, #featured-products .dc-stars');
    Array.prototype.forEach.call(boxes, function (box) {
      check(box);
      if (window.MutationObserver && !box.__dcObs) {
        box.__dcObs = new MutationObserver(function () { check(box); });
        box.__dcObs.observe(box, { childList: true, subtree: true, characterData: true });
      }
    });
    trimLabels();
    designCards();
    blogTags();
  }
  function blogTags() {
    var sec = document.querySelector('#sub-content-right .blog-tags');
    if (!sec || sec.__dcsel) return;
    var links = sec.querySelectorAll('ul.blog-tags-list a');
    if (!links.length) return;
    sec.__dcsel = true;
    var sel = document.createElement('select');
    sel.className = 'dc-tagsel';
    sel.setAttribute('aria-label', 'Browse articles by tag');
    var o0 = document.createElement('option');
    o0.value = ''; o0.textContent = 'Choose a tag';
    sel.appendChild(o0);
    Array.prototype.forEach.call(links, function (a) {
      var o = document.createElement('option');
      o.value = a.getAttribute('href');
      o.textContent = a.textContent.trim();
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () { if (sel.value) location.href = sel.value; });
    var ul = sec.querySelector('ul.blog-tags-list');
    ul.style.display = 'none';
    ul.parentNode.insertBefore(sel, ul);
    var st = document.createElement('style');
    st.textContent = '.dc-tagsel{width:100%;height:40px;padding:0 36px 0 14px;border:1px solid #eadfce;border-radius:10px;background:#fff url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%277%27 viewBox=%270 0 12 7%27%3E%3Cpath d=%27M1 1l5 5 5-5%27 fill=%27none%27 stroke=%27%23392919%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E") no-repeat right 14px center;color:#392919;font:700 13px Arial,Helvetica,sans-serif;-webkit-appearance:none;appearance:none;cursor:pointer;margin-bottom:6px}.dc-tagsel:hover,.dc-tagsel:focus{border-color:#eb6035;outline:0}';
    document.head.appendChild(st);
  }
  function trimLabels() {
    var ls = document.querySelectorAll('.collection-filter > label');
    Array.prototype.forEach.call(ls, function (l) {
      var t = l.textContent;
      if (/^\s*refine by\s+/i.test(t)) l.textContent = t.replace(/^\s*refine by\s+/i, '');
    });
  }
  function designCards() {
    var lis = document.querySelectorAll('li.product');
    Array.prototype.forEach.call(lis, function (li) {
      if (li.__dcd || li.querySelector('.dc-design')) return;
      var link = null;
      Array.prototype.forEach.call(li.querySelectorAll('a[href*="/products/"]'), function (a) {
        var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
        if (!link && m && DESIGN_HANDLES.indexOf(m[1]) > -1) link = a;
      });
      if (!link) return;
      var btn = li.querySelector('.add-cart-btn');
      if (!btn) return;
      li.__dcd = true;
      var d = document.createElement('div');
      d.className = 'dc-notify dc-design';
      var a2 = document.createElement('a');
      a2.className = 'add-to-cart-button';
      a2.href = link.href;
      a2.textContent = 'Design';
      d.appendChild(a2);
      btn.parentNode.insertBefore(d, btn);
      btn.parentNode.removeChild(btn);
      var q = li.querySelector('.dc-qty');
      if (q) q.parentNode.removeChild(q);
      var all = li.querySelectorAll('*');
      Array.prototype.forEach.call(all, function (el) {
        if (el.children.length === 0 && /^\s*£\s*[\d,.]+\s*$/.test(el.textContent) && !el.closest('s, del, .dc-save')) {
          el.innerHTML = '<small>From</small> ' + DESIGN_FROM;
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setTimeout(trimLabels, 800);
  setTimeout(blogTags, 800);
  if (window.MutationObserver) {
    var pend = 0;
    new MutationObserver(function () {
      if (pend) return;
      pend = setTimeout(function () { pend = 0; designCards(); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function inArea(el) { return !!(el.closest && el.closest('#product-listings, #featured-products, #dc-recent, #dc-popular, #dc-fbt, .dc-feat, .dc-fp')); }

  function qtyOf(li) {
    var i = li.querySelector('.dc-qty input');
    var n = parseInt(i && i.value, 10);
    return n > 0 ? Math.min(n, 99) : 1;
  }

  function okAdd(p) { if (window.addToCartOk) window.addToCartOk(p); }
  function failAdd() { if (window.addToCartFail) window.addToCartFail(); }

  // capture phase: runs before the theme's own click code
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var step = t.closest('.dc-qty button');
    if (step && inArea(step)) {
      e.preventDefault();
      var inp = step.parentNode.querySelector('input');
      var n = parseInt(inp.value, 10) || 1;
      n += step.getAttribute('data-d') === '1' ? 1 : -1;
      inp.value = Math.max(1, Math.min(99, n));
      return;
    }

    var buy = t.closest('li.product .add-cart-btn .add-to-cart-button');
    if (!buy || !inArea(buy)) return;
    var li = buy.closest('li.product');
    var q = qtyOf(li);
    var id = buy.getAttribute('data-proid');
    if (!id) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (window.jQuery && window.jQuery.ajax) {
      window.jQuery.ajax({ type: 'POST', url: '/cart/add.js', data: { id: Number(id), quantity: q }, dataType: 'json', success: okAdd, error: failAdd });
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: q })
      }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(okAdd).catch(failAdd);
    }
  }, true);

  // typing in the box: keep it to a whole number from 1 to 99
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('.dc-qty') || !inArea(t)) return;
    var n = parseInt(t.value, 10);
    t.value = n > 0 ? Math.min(n, 99) : 1;
  });
})();